import { queryClient } from "./../../../../Api/queryClient";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addCountry,
  addCurrency,
  addRoles,
  companyList,
  getAllCountries,
  getCurrenciesList,
  getRolesList,
  getRolesPermissions,
  updateCountry,
  updateCurrency,
  updateRoles,
} from "./SuperSettingRepo";
import { showToast } from "../../../../utils/toastUtils";

export const useGetCompanyList = ({ enable = false }: { enable: boolean }) => {
  return useQuery({
    queryKey: ["GET_COMPANY_LIST"],
    queryFn: companyList,
    retry: false,
    enabled: enable,
  });
};

export const useGetCountryList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["GET_COUNTRY_LIST", params],
    queryFn: () => getAllCountries(params),
    retry: false,
    enabled: enable,
  });
};

export const useAddCountry = (body?: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addCountry,
    onSuccess: (data) => {
      showToast.success("Country Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_COUNTRY_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Add Country!");
    },
  });
};

export const useUpdateCountry = (body?: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCountry,
    onSuccess: (data) => {
      showToast.success("Country Updated Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_COUNTRY_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Updated Country!");
    },
  });
};

// getRolesList
export const useGetRolesList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["GET_ROLES_LIST", params],
    queryFn: () => getRolesList(params),
    retry: false,
    enabled: enable,
  });
};

// addRoles
export const useAddRoles = (body?: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addRoles,
    onSuccess: (data) => {
      showToast.success("Roles Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_ROLES_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Add Roles!");
    },
  });
};

// getRolesPermissions

export const useGetRolesPermission = ({
  enable = false,
}: {
  enable: boolean;
}) => {
  return useQuery({
    queryKey: ["GET_ROLES_LIST"],
    queryFn: getRolesPermissions,
    retry: false,
    enabled: enable,
  });
};

// updateRoles
export const useUpdateRoles = (body?: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateRoles,
    onSuccess: (data) => {
      showToast.success("Roles Updated Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_ROLES_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Update Roles!");
    },
  });
};

// getCurrenciesList
export const useCurrenciesList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["GET_CURRENCIES_LIST", params],
    queryFn: () => getCurrenciesList(params),
    retry: false,
    enabled: enable,
  });
};

// addCurrency
export const useAddCurrency = (body?: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addCurrency,
    onSuccess: (data) => {
      showToast.success("Currency Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_CURRENCIES_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Add Currency!");
    },
  });
};

// updateCurrency
export const useUpdateCurrency = (body?: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id?: string | number; body?: any }) =>
      updateCurrency(id, body),
    onSuccess: (data) => {
      showToast.success("Currency Updated Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_CURRENCIES_LIST"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Updated Currency!");
    },
  });
};
